import React, { useEffect, useRef } from 'react';

const useMountedState = () => {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return {
    get isMounted() {
      return isMounted.current;
    },
    get isUnMounted() {
      return !isMounted.current;
    },
  };
};

export { useMountedState };
